
import { FrontEndTariffModel } from "../front-end-tariff.model";
import { AirCalculatedChargesModel } from "./air-calculated-charges.model";

export class AirCalculatedFreightModel {
    airFreightTariffDetId: number;
    offerAirDetailId: number;
    airAllocationId: number;
    unitPrice: number;
    cwg: number;
    ratio: number;
    grossWeight: number;
    volume: number;
    totalFreight: number;
    grandTotal: number;
    currencyRate; //kur cevrimi içi: number;
    tariffCurrency: string;
    currency: string;
    errorCode: string;
    freightTariffValidFrom: Date;
    freightTariffValidTo: Date;
    freightTariffDetValidFrom: Date;
    freightTariffDetValidTo: Date;
    isMinFreight: boolean;
    airInfo: string;
    discountCode: string;
    discountUuid: string;
    transitTime: string;
    iata: string;
    airline: string;
    viaPort: string;
    viaPortCountryCode: string;
    viaPortCode: string;
    newProductUuid: string;
    uuid: string;
    dueDay: number;
    frontTariff: FrontEndTariffModel;
    endTariff: FrontEndTariffModel;
 
    deppfrequency: string[] = null;
    cargoFrequency: string[] = null;
    etd: Date;
    eta: Date;
    cutOffDate: Date;
    discount: AirCalculatedChargesModel;
    surcharges: AirCalculatedChargesModel[];
    originCharges: AirCalculatedChargesModel[];
    insuranceCharge: AirCalculatedChargesModel;
    agencyFeeCharge: AirCalculatedChargesModel;
    destinationCharges: AirCalculatedChargesModel[];
    frontEndTariffs: FrontEndTariffModel[];
}
